import React, { useState } from 'react';

const GENRE_COLORS = {
  'מדע בדיוני': '#2563eb',
  'אקשן':       '#dc2626',
  'קומדיה':     '#16a34a',
  'דרמה':       '#57534e',
  'מתח':        '#0891b2',
  'הרפתקאות':  '#c2410c',
  'אנימציה':    '#9333ea',
  'אימה':       '#9f1239',
  'מוזיקה':     '#b45309',
  'רומנטיקה':   '#db2777',
  'תיעודי':     '#0d9488',
};

const SIZES = {
  sm: { w: 34, h: 48, fs: 13, r: 6 },
  md: { w: 54, h: 76, fs: 20, r: 8 },
  xl: { w: 80, h: 120, fs: 28, r: 10 },
};

function Poster({ posterUrl, genre, letter, size = 'sm' }) {
  const [imgFailed, setImgFailed] = useState(false);
  const { w, h, fs, r } = SIZES[size] || SIZES.sm;

  if (posterUrl && !imgFailed) {
    return (
      <img
        src={posterUrl}
        alt=""
        onError={() => setImgFailed(true)}
        style={{
          width: w, height: h, borderRadius: r, objectFit: 'cover',
          flexShrink: 0, display: 'block',
          boxShadow: '0 2px 10px rgba(0,0,0,0.18)',
        }}
      />
    );
  }

  const color = GENRE_COLORS[genre] || '#475569';
  return (
    <div style={{
      width: w, height: h, borderRadius: r, flexShrink: 0,
      background: color,
      backgroundImage: 'repeating-linear-gradient(135deg,rgba(255,255,255,.13) 0,rgba(255,255,255,.13) 3px,transparent 3px,transparent 10px)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      fontSize: fs, fontWeight: 800, color: 'rgba(255,255,255,0.9)',
      boxShadow: '0 2px 10px rgba(0,0,0,0.22)',
    }}>
      {letter || (genre ? genre[0] : '?')}
    </div>
  );
}

export default Poster;
